// Single source for human-readable opening hours.
// Reads cfg.contact.hours - the SAME record that drives useOpenState() in the
// header. Never duplicate these values anywhere; add consumers here instead.
import { shopConfig as cfg } from './shopConfig';

type Slot = { open: number; close: number } | null;
const H = cfg.contact.hours as unknown as Record<number, Slot>;

// Display Monday-first; JS getDay() is Sunday = 0.
const ORDER = [1, 2, 3, 4, 5, 6, 0];
const LABEL: Record<number, string> = {
  0: 'Sunday', 1: 'Monday', 2: 'Tuesday', 3: 'Wednesday',
  4: 'Thursday', 5: 'Friday', 6: 'Saturday',
};
const SCHEMA: Record<number, string> = {
  0: 'Su', 1: 'Mo', 2: 'Tu', 3: 'We', 4: 'Th', 5: 'Fr', 6: 'Sa',
};

export const fmtMins = (m: number) =>
  `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;

export interface HourRow { day: string; text: string; closed: boolean; today: boolean }

// `today` uses the visitor's local day, not the shop timezone - cosmetic
// highlighting only. The authoritative open/closed answer stays with useOpenState().
export function hourRows(): HourRow[] {
  const todayIdx = new Date().getDay();
  return ORDER.map((d) => {
    const s = H[d];
    return {
      day: LABEL[d],
      text: s ? `${fmtMins(s.open)} - ${fmtMins(s.close)}` : 'Closed',
      closed: !s,
      today: d === todayIdx,
    };
  });
}

export function schemaOpeningHours(): string[] {
  return ORDER.filter((d) => H[d]).map((d) => `${SCHEMA[d]} ${fmtMins(H[d]!.open)}-${fmtMins(H[d]!.close)}`);
}